import pageStyle from "./index.module.less";
import LangSelect from "@/components/langSelect";
import { getStatementTypeList, getStatementSearch, setStatementTop } from "@/views/ticket/service";

export default {
    name: "quickReply",
    props: {},
    components: { LangSelect },
    data() {
        return {
            pageStyle,
            queryQuick: {
                language: "",
                type_id: "",
                keyword: "",
                page: 0
            },
            typeList: [],
            searchList: [],
            count: 0
        };
    },
    methods: {
        typeChange(value) {
            this.queryQuick.type_id = value;
            this.queryQuick.page = 0;
            this.query();
        },
        async keywordClick() {
            this.queryQuick.page = 0;
            this.query();
        },
        async keywordChange(value) {
            this.queryQuick.keyword = value;
            this.queryQuick.page = 0;
            this.query();
        },
        setContent(value) {
            this.$emit("getStatementContent", value);
        },
        async query() {
            let { page } = this.queryQuick;

            if (page != 0) {
                page = page - 1;
            }

            let { list, count } = await getStatementSearch({
                ...this.queryQuick,
                page: page
            });

            this.searchList = list;
            this.count = count;
        },
        async setCollection(value) {
            try {
                await setStatementTop({
                    id: value.id,
                    top: value.top == 0 ? 1 : 0
                });
                value.top = value.top == 0 ? 1 : 0;
            } catch (err) {
                console.log(err);
                value.top = value.top == 0 ? 1 : 0;
            }
        }
    },
    async created() {
        let { list } = await getStatementTypeList("all");
        this.typeList = list;
    },
    watch: {
        async "queryQuick.language"(value) {
            let { list } = await getStatementTypeList(value);
            this.typeList = list;
            this.queryQuick.page = 0;
            this.queryQuick.type_id = "";
            this.queryQuick.keyword = "";
            this.query();
        },
        "queryQuick.page"() {
            this.query();
        }
    }
};
